<script>
  import { onMount } from 'svelte'
  import { setupSvgAnimation } from '../scroll-driven-animations.ts'
  import { getViewBoxEndpoints } from '../view-box-calc.ts'
  import { getMarkers } from '../utils.ts'

  export let params
  export let viewTimeline
  export let isDesktop
  export let beskrivelse

  let innerWidth = 428
  let svgContainerEl
  let preserveAspectRatio = 'xMidYMid meet'

  onMount(() => {
    preserveAspectRatio = 'xMidYMid slice'
  })

  $: viewBoxEndpoints = getViewBoxEndpoints(innerWidth, params)
  $: startViewBox = viewBoxEndpoints.start
  $: endViewBox = viewBoxEndpoints.end
  $: width = startViewBox[2]
  $: height = startViewBox[3]
  $: svgOffsetEnd = 1 - (endViewBox[1] - startViewBox[1] + 0.5 * endViewBox[3]) / height
  $: {
    if (viewTimeline) {
      setupSvgAnimation(viewTimeline, svgContainerEl, svgOffsetEnd)
    }
  }
  $: markers = getMarkers(params.markers, isDesktop)

  let visible = false
  function intersection(node) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible = true
          }
        }
      },
      {
        threshold: 0,
        rootMargin: '100px 0px 100px 0px',
      },
    )
    observer.observe(node)
  }
</script>

<svelte:window bind:innerWidth />
<div
  class="height-container"
  style={`--aspect-ratio: ${width.toFixed(2)} / ${height.toFixed(2)}`}
  use:intersection
>
  <div class="svg-container" bind:this={svgContainerEl}>
    <svg
      {width}
      {height}
      viewBox={startViewBox.join(' ')}
      role="img"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {preserveAspectRatio}
      aria-label={beskrivelse}
    >
      <slot {markers} svgVisible={visible} />
    </svg>
  </div>
</div>

<style>
  .height-container {
    position: absolute;
    inset: 0;
    overflow: clip;
  }

  .svg-container {
    contain: strict;
    display: block;
    position: absolute;
    inset: 0;
    will-change: opacity;
  }

  :global(.aktiv) .svg-container {
    top: auto;
    aspect-ratio: var(--aspect-ratio);
  }

  svg {
    position: absolute;
    contain: paint layout;
    display: block;
    width: 100%;
    height: 100%;
  }

  :global(.aktiv) svg {
    height: auto;
  }
</style>
